import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_AGE007_Request,
  IAPI_AGE007_Response,
} from "../../../type/apiType";

// 代行入力依頼参照API
// API仕様書_代行者
const httpAPI_AGE007 = async (
  param: IAPI_AGE007_Request
): Promise<IAPI_AGE007_Response> => {
  let res = await http.post(ApiUrl.API_AGE007, {
    ...param,
  });
  return res.data;
};

export { httpAPI_AGE007 };
